import PlatformNotificationsCard from './PlatformNotificationsCard.vue'

export default PlatformNotificationsCard